// extracted by css-extract-rspack-plugin
export default {"cls1":"LandingScreen-cls1_7sU","cls2":"LandingScreen-cls2_1dA LandingScreen-cls1_7sU"};